import PeopleIcon from '@mui/icons-material/People';
import EventIcon from '@mui/icons-material/Event';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DnsIcon from '@mui/icons-material/Dns';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsIcon from '@mui/icons-material/Settings';
import type { MenuItem } from '../NavigationSideMenu.types';

export const MENU_ITEMS: MenuItem[] = [
  {
    key: 'employees',
    labelKey: 'menu.employees',
    icon: <PeopleIcon />,
    path: '/employees',
    permission: 'employee_list',
  },
  {
    key: 'leaves',
    labelKey: 'menu.leaves',
    icon: <EventIcon />,
    path: '/leaves',
    permission: 'leave_list',
  },
  {
    key: 'payroll',
    labelKey: 'menu.payroll',
    icon: <DescriptionIcon />,
    path: '/payroll',
    permission: 'payslip_list',
  },
  {
    // No catalogue line maps to reporting (HOMCO-640 spec) — left ungated.
    key: 'reporting',
    labelKey: 'menu.reporting',
    icon: <AssessmentIcon />,
    path: '/reporting',
  },
  {
    key: 'myNGO',
    labelKey: 'menu.myNGO',
    icon: <AccountTreeIcon />,
    subItems: [
      {
        key: 'users',
        labelKey: 'submenu.users',
        path: '/my-ngo/users',
        icon: <ManageAccountsIcon />,
        permission: 'users',
      },
      {
        key: 'rightsProfiles',
        labelKey: 'submenu.rightsProfiles',
        path: '/my-ngo/user-rights',
        icon: <AdminPanelSettingsIcon />,
        permission: 'rights_profiles',
      },
      {
        key: 'instances',
        labelKey: 'submenu.instances',
        path: '/instances',
        icon: <DnsIcon />,
        permission: 'instances',
      },
      {
        key: 'generalSettings',
        labelKey: 'submenu.generalSettings',
        path: '/my-ngo/general-settings',
        icon: <SettingsIcon />,
        permission: 'general_settings',
      },
    ],
  },
] as const;
